import { Modal } from 'antd';
import { useAppTranslation, useErrTranslation } from 'app/hooks';
import CloseIcon from 'assets/icons/CloseIcon';
import React, { useEffect, useState } from 'react';
import { useMessageSuccess } from 'hooks/useMessageSuccess';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import useThemes from 'hooks/useThemes';
import walletApi from 'api/walletApi';
import { UserBankbookResponseModel } from 'models/wallet';
import ListUserBankbook from '../UserBankbook/ListUserBankbook';
import AddUserBankbook from '../UserBankbook/AddUserBankbook';

interface UserBankbookModalProps {
  title?: string;
  visible: boolean;
  closeModal: () => void;
  className?: string;
}

type FormInputs = {
  amount: string;
  disbursementNumber?: string;
  branchTransitNumber?: string;
  accountNumber?: string;
};

const UserBankbookModal: React.FunctionComponent<UserBankbookModalProps> = (props) => {
  const { title = '', visible, closeModal, className = '' } = props;
  const { currentTheme } = useThemes();
  const handleResponseError = useHandleResponseError();
  const t = useAppTranslation();
  const et = useErrTranslation();
  const { showToast, contextHolder } = useMessageSuccess();
  const [userBankbooks, setUserBankbooks] = useState<UserBankbookResponseModel[] | undefined>([]);
  const [isAdding, setIsAdding] = useState<boolean>(false);

  const onCloseModal = () => {
    setIsAdding(false);
    closeModal();
  };

  const getUserBankbooks = async () => {
    const { ok, body } = await walletApi.getUserBankbooks();
    if (ok) {
      setUserBankbooks(body);
    }
  };

  const onDelete = async (id: number) => {
    const { ok, error } = await walletApi.deleteUserBankbooks(id);
    if (ok) {
      getUserBankbooks();
    }

    if (error) handleResponseError(error);
  };

  const onBack = () => {
    getUserBankbooks();
    setIsAdding(false);
  };

  const handleOpenAddNewBankbook = () => {
    setIsAdding(true);
  };

  useEffect(() => {
    getUserBankbooks();
  }, []);

  return (
    <Modal
      className={className}
      title={title}
      visible={visible}
      onCancel={onCloseModal}
      footer={null}
      centered
      maskClosable={false}
      closeIcon={<CloseIcon isDarkMode={currentTheme === 'dark'} width="20" height="20" />}
      width={600}
    >
      <div className="center-content-col gap-2 primary-text-color">
        {isAdding ? (
          <AddUserBankbook onBack={onBack} />
        ) : (
          <>
            <ListUserBankbook onDeleteUserBankbook={onDelete} userBankbooks={userBankbooks} />
            <button
              className={`mt-2 button-generate`}
              type="button"
              onClick={handleOpenAddNewBankbook}
            >
              {t('userBankbook.addNewBankbook')}
            </button>
          </>
        )}
      </div>

      {contextHolder}
    </Modal>
  );
};

export default UserBankbookModal;
